<template>
  <div>
    <loader :loader="sending" />
    <v-data-table :headers="computedHeaders" :items="listHistoy" :items-per-page="itemsPerPage" :search="search"
      no-data-text="Sin resultados disponibles" class="mx-5" dense fixed-header height="auto" hide-default-footer>
      <template v-slot:[`item.intepretationDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.intepretationDate) }}
      </template>
      <template v-slot:[`item.startDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.startDate) }}
      </template>
      <template v-slot:[`item.nameInterpreter`]="{ item }">
        <span>
          {{ item.nameInterpreter }}
          <span v-if="item.validatorName !== ''">
            <br />
            <small style="font-style: italic; font-weight: bold;">Validó: <br /> {{ item.validatorName }}</small>
          </span>
        </span>
      </template>
      <template v-slot:[`item.birads`]="{ item }">
        <v-chip :color="getBiradsColor(item)" small>
          {{ getBiradsLabel(item) }}
        </v-chip>
      </template>
      <template v-slot:[`item.biradsRevalidation`]="{ item }">
  <v-chip :color="item?.colorBiradsRevalidation || 'nobirad'" small>
    {{ item?.revalidated ? (item?.biradsRevalidation || "N/A") : "N/A" }}
  </v-chip>
</template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small icon @click="exportToPDF(item)"  v-if="$utilFront.withPermission($prm.INTERPRETATION_REPORT_DONWLOAD)">
              <v-icon color="error" v-bind="attrs" v-on="on">
                mdi-file-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span> Descargar PDF </span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              icon
              v-bind="attrs"
              v-on="on"
              :disabled="!item?.revalidated"
              @click="item?.revalidated && exportToPDFRevalidation(item)"
              v-if="$utilFront.withPermission($prm.DOWNLOAD_REPORT_REVALIDATE)"
            >
              <v-icon color="error">mdi-file-pdf-box</v-icon>
            </v-btn>
          </template>
          <span>
            {{ item?.revalidated ? 'Descargar revalidación' : 'Aún no tiene revalidación' }}
          </span>
        </v-tooltip>
        <v-menu v-if="showMoreOptions(item)" >
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn small icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <span>Más opciones</span>
            </v-tooltip>
          </template>
          <!-- getDataEdit(item) -->
          <v-list dense>
            <v-list-item link @click="isEditableTable(item)" 
              v-if="$utilFront.withPermission($prm.INTERPRETATION_EDIT_ALL)">
              <v-list-item-icon>
                <v-icon color="warning"> mdi-pencil </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Editar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              @click="abrirFormularioDeRevalidacion(item)"
              v-if="!item?.idInterpretationRevalidated && $utilFront.withPermission($prm.REVALIDATE_EDIT_ALL)"
            >
              <v-list-item-icon>
                <v-icon color="warning">mdi-pencil</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Revalidar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              @click="abrirFormularioDeRevalidacion(item)"
              v-if="!!item?.idInterpretationRevalidated && $utilFront.withPermission($prm.REVALIDATE_EDIT_STUDY)"
            >
              <v-list-item-icon>
                <v-icon color="warning">mdi-pencil</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Editar revalidación</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link @click="downloadViewer(item.idStudy)" v-if="$utilFront.withPermission($prm.INTERPRETATION_VISUALIZER)">
              <v-list-item-icon>
                <v-icon color="amber"> mdi mdi-comment-eye </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Visualizador </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="downloadZIP(item)" v-if="$utilFront.withPermission($prm.DOWNLOAD_DICOM_INT)">
              <v-list-item-icon>
                <v-icon color="secondary"> mdi-folder-download </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> DICOM </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="changeViewAddendums(item)" v-if="$utilFront.withPermission($prm.INTERPRETATION_ATTACHED_FILES)">
              <v-list-item-icon>
                <v-icon color="cyan"> mdi-file-image </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Archivos anexos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <view-image-int-item :send="() => sending = !sending" :sending="sending" :idStudy="item.idStudy"
              v-if="$utilFront.withPermission($prm.VIEWER_WEB_INT)" />

          </v-list>
        </v-menu>
      </template>

  <template v-slot:[`item.revalidated`]="{ item }">
    {{ item.revalidated ? "REVALIDADO" : "NO REVALIDADO" }}
  </template>
    </v-data-table>
    <v-card-actions align="center">
      <v-col>
        <v-btn outlined small color="green darken-1" :disabled="sending" @click="downloadReportXLSX()" v-if="!isMedicoInterpreteSuperior">
          {{ sending ? "Exportando..." : "Exportar interpretaciones" }}
          <v-icon right>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          outlined
          small
          color="red darken-1"
          :disabled="sending"
          @click="openProductivityRevalidationDialog()"
          v-if="showProductivoRevalidacionBtn && $utilFront.withPermission($prm.DOWNLOAD_PRODUCTIVITY_REVALIDATE)"
        >
          {{ sending ? "Descargando..." : "Descargar productivo revalidación" }}
        </v-btn>
      </v-col>
    </v-card-actions>
    <v-dialog v-model="dialogCancelation" persistent max-width="70%" v-if="dialogCancelation">
      <cancelation-modal :dataModal="dataModal" @closeCancelationDialog="closeCancelationDialog"
        :dialogCancelation="dialogCancelation" />
    </v-dialog>
   <v-dialog v-model="dialogProductivityRevalidation" max-width="420">

  <v-card>

    <v-card-title>Selecciona una fecha</v-card-title>

    <v-card-text class="pa-0">

      <vc-date-picker

        color="green"

        v-model="productivityDate"

        :max-date="new Date()"

        style="width: 100%;"

      />

    </v-card-text>

    <v-card-actions>

      <v-spacer />

      <v-btn text :disabled="sending" @click="dialogProductivityRevalidation = false">

        Cancelar

      </v-btn>

      <v-btn
        outlined
        color="green darken" 

        :disabled="sending || !productivityDate"

        @click="confirmDownloadProductivityRevalidation()"

      >

        Descargar

      </v-btn>

    </v-card-actions>

  </v-card>

</v-dialog>
  </div>
</template>

<script>

import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import CancelationModal from "@/app/components/common/CancelationModal.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import ViewImageIntItem from "@/app/components/common/study/ViewImageInterItem.vue";
import ColposcopyForm from "@/core/request/ColposcopyForm";
import { InterpretationHistoryService } from "@/app/services";

import {
  ReportPDFRequest,
  DownloadZipRequest,
  StudyRequest,
} from "@/core/request";
export default {
  name: "SpecialityTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    itemsPerPage: Number,
    biRadsSelect: Number,
    listAllPagination: Function,
    getAddendums: Function,
    search: String,
    range: Object,
    idBranchOffice: String,
    modalitiesSelect: String,
    showProductivoRevalidacionBtn: {
    type: Boolean,
    default: false
  },
  revalidatedFilter: {
    type: Boolean,
    default: null
  }
  },
  components: {
    MenuCrud,
    CancelationModal,
    Loader,
    ViewImageIntItem
  },
  data() {
    return {
      dialogCancelation: false,
      dataModal: {},
      listHistoy: [],
      sending: false,
      dialogProductivityRevalidation: false,
      productivityDate: null,
      headers: [
        {
          text: "Id Interpretación",
          value: "idInterpretation",
          sortable: false,
          align: "center",
        },
        {
          text: "Id Estudio",
          value: "idStudy",
          align: "center",
          sortable: false,
        },
        {
          text: "Nombre del paciente",
          value: "patient",
          sortable: false,
          align: "center",
        },
        {
          text: "Modalidad",
          value: "modality",
          sortable: false,
          align: "center",
        },
        {
          text: "Estudio",
          value: "studyModality",
          sortable: false,
          align: "center",
        },
        {
          text: "BI-RADS",
          value: "birads",
          sortable: false,
          align: "center",
        },
        {
          text: "Fecha de interpretación",
          value: "intepretationDate",
          sortable: false,
          align: "center",
        },
        {
          text: "Fecha del estudio",
          value: "startDate",
          sortable: false,
          align: "center",
        },
        {
          text: "Intérprete",
          value: "nameInterpreter",
          sortable: false,
          align: "center",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width:"8%"
        },
      ],
    };
  },
  watch: {
    list: function () {
      this.setlistWithBiradsChanges();
    },
  },
 computed: {
  isMedicoInterpreteSuperior() {
  const roleRaw = (this.$utilFront.getRole?.() || "");
  const role = roleRaw
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

  return role === "medico interprete supervisor";
},


   roleNormalized() {
    const roleRaw = (this.$utilFront.getRole?.() || "");
    return roleRaw
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  },

  isMesaDeControl() {
    return this.roleNormalized === "mesa de control";
  },

  isMedicoInterpreteSuperior() {
    return (
      this.roleNormalized === "medico interprete supervisor" ||
      this.roleNormalized === "medico interprete superior"
    );
},

  isMedicoInterprete() {
    return this.roleNormalized === "medico interprete";
  },


  computedHeaders() {
    const h = [...this.headers];

    if (this.isMesaDeControl) {
      const idxBirads = h.findIndex(x => x.value === "birads");
      const biradsRevalidatorCol = {
        text: "BI-RADS revalidador",
        value: "biradsRevalidation",
        sortable: false,
        align: "center",
      };

      if (idxBirads >= 0) h.splice(idxBirads + 1, 0, biradsRevalidatorCol);
      else h.push(biradsRevalidatorCol);

      const idxInterpreter = h.findIndex(x => x.value === "nameInterpreter");
      const idxActions = h.findIndex(x => x.value === "actions");

      const estatusCol = {
        text: "Estatus",
        value: "revalidated",
        sortable: false,
        align: "center",
      };

      if (idxInterpreter >= 0) {
        h.splice(idxInterpreter + 1, 0, estatusCol);
      } else if (idxActions >= 0) {
        h.splice(idxActions, 0, estatusCol);
      } else {
        h.push(estatusCol);
      }
    }

    return h;
  },

  productivityDateComputed() {
    if (!this.productivityDate) return "";
      return `${this.$utilFront.formatDate(this.productivityDate)}`;
    },


},
  methods: {
    setlistWithBiradsChanges() {
      this.listHistoy = this.list.map((obj) => {
        obj.birads = obj.birads ? obj.birads : "NA";
        obj.colorBirads = obj.colorBirads ? obj.colorBirads : "nobirad";
        return obj;
      });
    },
    isEditableTable(item) {
  const isSupervisor = this.isMedicoInterpreteSuperior;

  const interpretationIdToSend = isSupervisor
    ? item?.idInterpretationRevalidated
    : item?.idInterpretation;

  if (item?.modality && item.modality.toUpperCase() === "COLPOSCOPIA") {
    const payloadQuestions = {
      evaluationTypes: [13],
      idPerson: item.idPerson,
      idStudy: item.idStudy
    };

    ColposcopyForm.editColposcopyFormFromInterpretation(payloadQuestions)
      .then((respColposcopy) => {
        const newData = respColposcopy.data;

        const mappedData = newData.map((calculator) => {
          const mappedQuestions = calculator.dataQuestions.map((q) => {
            if (q.typeAnswer === 2 && q.idAnswer) q.answerClosed = q.idAnswer;
            return q;
          });

          return {
            idEvaluation: calculator.idCalculator,
            name: calculator.name,
            description: calculator.name,
            key: calculator.idCalculator,
            type: calculator.type,
            questions: mappedQuestions
          };
        });

        this.$emit("colposcopyLoaded", mappedData);
        return this.get(interpretationIdToSend, 3);
      })
      .catch((error) => {
        this.$utilFront.errorhttp(error);
      });
  } else {
    this.get(interpretationIdToSend, 3);
  }
},

abrirFormularioDeRevalidacion(item) {
    const currentHR = this.$utilFront.getIdHumanResource();
    const tieneRevalidacion = !!item?.idInterpretationRevalidated && !!item?.idHumanResourceRevalidator;

     if (tieneRevalidacion && item.idHumanResourceRevalidator !== currentHR) {
        if (this.$toast?.error) {
          this.$toast.error("No tiene permiso para revalidar este estudio");
        } else if (this.$toast?.open) {
          this.$toast.open({ message: "No tiene permiso para revalidar este estudio", type: "error" });
        } else {
          this.$utilFront.notifications("No tiene permiso para revalidar este estudio", "ERROR");
        }
        return;
      }

    const rutaDestino = tieneRevalidacion ? "REVALIDATION-HISTORY" : "REVALIDATION-PENDING";

    const idParaAbrir = tieneRevalidacion ? item.idInterpretationRevalidated : item.idStudy;
    const tipoParaAbrir = tieneRevalidacion ? 3 : 2;

    this.$router
      .push({
        name: rutaDestino,
        query: {
          autoOpenId: idParaAbrir,
          autoOpenType: String(tipoParaAbrir),
          idStudy: item.idStudy,

          
        }
      })
  },

showMoreOptions(item) {
  const canEdit = this.$utilFront.withPermission(this.$prm.INTERPRETATION_EDIT_ALL);
  const downloadReport = this.$utilFront.withPermission(this.$prm.INTERPRETATION_REPORT_DONWLOAD);
  const canRevalidate =
  !item?.idInterpretationRevalidated &&
  this.$utilFront.withPermission(this.$prm.REVALIDATE_EDIT_ALL);

  const canEditRevalidation =
  !!item?.idInterpretationRevalidated &&
  this.$utilFront.withPermission(this.$prm.REVALIDATE_EDIT_STUDY);
  const downloadReportRevalidate = this.$utilFront.withPermission(this.$prm.DOWNLOAD_REPORT_REVALIDATE);
  const canViewer = this.$utilFront.withPermission(this.$prm.INTERPRETATION_VISUALIZER);
  const canDicom = this.$utilFront.withPermission(this.$prm.DOWNLOAD_DICOM_INT);
  const canAddendums = this.$utilFront.withPermission(this.$prm.INTERPRETATION_ATTACHED_FILES);
  const canWebViewer = this.$utilFront.withPermission(this.$prm.VIEWER_WEB_INT);



return canEdit || canViewer || canDicom || canAddendums || canWebViewer
  || downloadReport || downloadReportRevalidate
  || canRevalidate || canEditRevalidation;
},

getBiradsLabel(item) {
  if (this.isMedicoInterpreteSuperior) {
    return item?.biradsRevalidation ?? "N/A";
  }
  return item?.birads || "NA";
},

getBiradsColor(item) {
  if (this.isMedicoInterpreteSuperior) {
    return item?.colorBiradsRevalidation ?? "nobirad";
  }
  return item?.colorBirads || "nobirad";
},




    checkCancel(item) {
      this.dataModal = {};
      this.dataModal = Object.assign(this.dataModal, item);
      this.dataModal.birthDate = this.$utilFront.formatDate(
        this.dataModal.birthDate
      );
      this.dialogCancelation = true;
    },
    closeCancelationDialog(e) {
      this.dialogCancelation = e;
      this.deleteItem();
    },
    downloadViewer(item) {
      try {
        this.sending = true;
        let data = {
          idStudy: item,
          idBranchOffice: this.$utilFront.getIdBranchOffice(),
        };
        StudyRequest.findURLJNLP(data)
          .then((res) => {
            window.open(res.data, "_blank").focus();
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },
  downloadZIP(item) {
  this.sending = true;
  try {
    let data = { idStudy: item.idStudy };
    DownloadZipRequest.downloadImagesDCM(data)
      .then((res) => {
        let filename = '';
        
        if (item.patient && item.idPatient) {
          const nameParts = item.patient.trim().split(/\s+/).filter(part => part !== '');
          const numParts = nameParts.length;
          
          if (numParts === 1) {
            filename = `${nameParts[0]} - ${item.idPatient}.zip`;
          } else if (numParts === 2) {
            const apellidoPaterno = nameParts[1];
            const nombres = nameParts[0];
            filename = `${apellidoPaterno}${nombres} - ${item.idPatient}.zip`;
          } else {
            let apellidosCount;
            
            if (numParts === 3) {
              apellidosCount = 2;
            } else if (numParts === 4) {
              apellidosCount = 2;
            } else {
              apellidosCount = 2;
            }
            
            const apellidos = nameParts.slice(-apellidosCount);
            const nombres = nameParts.slice(0, -apellidosCount).join('');
            
            const apellidoPaterno = apellidos[0];
            const apellidoMaterno = apellidos[1] || '';
            const apellidosCompletos = apellidoPaterno + apellidoMaterno;
            
            filename = `${apellidosCompletos}${nombres} - ${item.idPatient}.zip`;
          }
        } else {
          filename = `${item.idPatient}.zip`;
        }

        const url = URL.createObjectURL(
          new Blob([res.data], {
            type: "application/zip",
          })
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 60000);
      })
      .catch(this.catchError)
      .finally(() => {
        this.sending = false;
      });
  } catch (e) {
    this.catchError(e);
  }
},
   exportToPDF(interpretation) {
  this.sending = true;

    const data = {
      idInterpretation: interpretation.idInterpretation,
      interpretationText: "",
      fileName: "Interpretacion",
    };

    ReportPDFRequest.downloadInterpretation1(data)
      .then((res) => {
        let filename = "";
        let displayName = "";

        if (interpretation.patient && interpretation.idPatient) {
          const nameParts = interpretation.patient
            .trim()
            .split(/\s+/)
            .filter((part) => part !== "");
          const numParts = nameParts.length;

          if (numParts === 1) {
            filename = `${nameParts[0]} - ${interpretation.idPatient}.pdf`;
            displayName = `${nameParts[0]} - ${interpretation.idPatient}`;
          } else if (numParts === 2) {
            const apellidoPaterno = nameParts[1];
            const nombres = nameParts[0];
            filename = `${apellidoPaterno}${nombres} - ${interpretation.idPatient}.pdf`;
            displayName = `${apellidoPaterno}${nombres} - ${interpretation.idPatient}`;
          } else {
            const apellidosCount = 2;

            const apellidos = nameParts.slice(-apellidosCount);
            const nombres = nameParts.slice(0, -apellidosCount).join("");

            const apellidoPaterno = apellidos[0] || "";
            const apellidoMaterno = apellidos[1] || "";
            const apellidosCompletos = `${apellidoPaterno}${apellidoMaterno}`;

            filename = `${apellidosCompletos}${nombres} - ${interpretation.idPatient}.pdf`;
            displayName = `${apellidosCompletos}${nombres} - ${interpretation.idPatient}`;
          }
        } else {
          filename = `Interpretacion-${interpretation.idInterpretation}.pdf`;
          displayName = `Interpretacion-${interpretation.idInterpretation}`;
        }

        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        const pdfUrl = URL.createObjectURL(pdfBlob);

        const htmlContent = `
  <!DOCTYPE html>
  <html>
  <head>
    <title>${displayName}</title>
    <style>
      body, html { margin: 0; padding: 0; height: 100%; overflow: hidden; }
      embed { width: 100%; height: 100%; border: none; }
    </style>
  </head>
  <body>
    <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%">
  </body>
  </html>`;

        const htmlBlob = new Blob([htmlContent], { type: "text/html" });
        const htmlUrl = URL.createObjectURL(htmlBlob);

        window.open(htmlUrl, "_blank");

        const link = document.createElement("a");
        link.href = pdfUrl;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
          URL.revokeObjectURL(pdfUrl);
          URL.revokeObjectURL(htmlUrl);
        }, 60000);

        this.sending = false;
      })
      .catch((error) => {
        this.sending = false;
        this.catchError(error);
      });
  },

  exportToPDFRevalidation(interpretation) {
  this.sending = true;

    const data = {
      idInterpretation: interpretation.idInterpretation,
      interpretationText: "",
      fileName: "Interpretacion",
      ...(interpretation?.revalidated === true ? { withRevalidation: true } : {}),
    };

    ReportPDFRequest.downloadInterpretation1(data)
      .then((res) => {
        let filename = "";
        let displayName = "";

        if (interpretation.patient && interpretation.idPatient) {
          const nameParts = interpretation.patient
            .trim()
            .split(/\s+/)
            .filter((part) => part !== "");
          const numParts = nameParts.length;

          if (numParts === 1) {
            filename = `${nameParts[0]} - ${interpretation.idPatient}.pdf`;
            displayName = `${nameParts[0]} - ${interpretation.idPatient}`;
          } else if (numParts === 2) {
            const apellidoPaterno = nameParts[1];
            const nombres = nameParts[0];
            filename = `${apellidoPaterno}${nombres} - ${interpretation.idPatient}.pdf`;
            displayName = `${apellidoPaterno}${nombres} - ${interpretation.idPatient}`;
          } else {
            const apellidosCount = 2;

            const apellidos = nameParts.slice(-apellidosCount);
            const nombres = nameParts.slice(0, -apellidosCount).join("");

            const apellidoPaterno = apellidos[0] || "";
            const apellidoMaterno = apellidos[1] || "";
            const apellidosCompletos = `${apellidoPaterno}${apellidoMaterno}`;

            filename = `${apellidosCompletos}${nombres} - ${interpretation.idPatient}.pdf`;
            displayName = `${apellidosCompletos}${nombres} - ${interpretation.idPatient}`;
          }
        } else {
          filename = `Interpretacion-${interpretation.idInterpretation}.pdf`;
          displayName = `Interpretacion-${interpretation.idInterpretation}`;
        }

        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        const pdfUrl = URL.createObjectURL(pdfBlob);

        const htmlContent = `
  <!DOCTYPE html>
  <html>
  <head>
    <title>${displayName}</title>
    <style>
      body, html { margin: 0; padding: 0; height: 100%; overflow: hidden; }
      embed { width: 100%; height: 100%; border: none; }
    </style>
  </head>
  <body>
    <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%">
  </body>
  </html>`;

        const htmlBlob = new Blob([htmlContent], { type: "text/html" });
        const htmlUrl = URL.createObjectURL(htmlBlob);

        window.open(htmlUrl, "_blank");

        const link = document.createElement("a");
        link.href = pdfUrl;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
          URL.revokeObjectURL(pdfUrl);
          URL.revokeObjectURL(htmlUrl);
        }, 60000);

        this.sending = false;
      })
      .catch((error) => {
        this.sending = false;
        this.catchError(error);
      });
  },

    changeViewAddendums(item) {
      this.sending = true;
      this.objectInterpretation = item;
      this.getAddendums(item, 1);
    },
    downloadReportXLSX() {
      if (this.sending) return;

      this.sending = true;

      let params = {
        idBirads: this.biRadsSelect,
        search: this.search,
        idBranchOffice: this.idBranchOffice != null ? this.idBranchOffice : this.$utilFront.getIdBranchOffice(),
      };

      if (this.$utilFront.nonEmpty(this.modalitiesSelect)) {
        params.idModality = this.modalitiesSelect;
      }

      let rangeName = "";
      if (this.$utilFront.nonEmpty(this.range)) {
        params.start = this.$utilFront.startOfDay(this.range.start);
        params.end = this.$utilFront.endOfDay(this.range.end);
        rangeName = ` del ${this.$utilFront.formatDate(params.start)} al ${this.$utilFront.formatDate(params.end)}`;
      }

      if (this.isMesaDeControl && this.revalidatedFilter !== null) {
        params.withRevalidation = this.revalidatedFilter;
      }

      let fileName = `Historial de interpretaciones${rangeName}.xlsx`;

      InterpretationHistoryService.downloadReportHistoryXLSX(params)
        .then((response) => {
          let { data } = response;
          this.$utilFront.downloadXLSX(data, fileName);
        })
        .catch((error) => {
          this.$utilFront.errorhttp(error);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    openProductivityRevalidationDialog() {

    if (this.sending) return;

    this.productivityDate = null;

    this.dialogProductivityRevalidation = true;

  },



  confirmDownloadProductivityRevalidation() {

    if (!this.productivityDate) {

      if (this.$toast?.error) this.$toast.error("Selecciona una fecha para descargar.");

      else this.$utilFront.notifications("Selecciona una fecha para descargar.", "ERROR");

      return;

    }



    this.dialogProductivityRevalidation = false;

    this.downloadProductivityRevalidation();

  },



  async downloadProductivityRevalidation() {

    if (this.sending) return;



    if (!this.productivityDate) {

      if (this.$toast?.error) this.$toast.error("Selecciona una fecha para descargar.");

      else this.$utilFront.notifications("Selecciona una fecha para descargar.", "ERROR");

      return;

    }



    this.sending = true;



    const idBranchOfficeToSend =

      this.idBranchOffice != null && this.idBranchOffice !== ""

        ? this.idBranchOffice

        : this.$utilFront.getIdBranchOffice();



    try {

      const dateStart = this.$utilFront.startOfDay(this.productivityDate);

      const dateEnd   = this.$utilFront.endOfDay(this.productivityDate);



      const payload = {

        asPDF: false,

        idBranchOffice: idBranchOfficeToSend,

        speciality: 2,

        status: [6],

        idModalities: ["C-4", "C-11", "C-2"],

        withRevalidation: true,

        dateStart,

        dateEnd,


        dateFull: this.$utilFront.buildDateFull(dateStart, dateStart),

      };



      const res = await ReportPDFRequest.getReportProductivityRevalidation(payload);



      const blob = new Blob([res.data], { type: "application/zip" });

      const url = URL.createObjectURL(blob);



      const fileName = "Productivo revalidación.zip";

      const link = document.createElement("a");

      link.href = url;

      link.setAttribute("download", fileName);

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);



      setTimeout(() => URL.revokeObjectURL(url), 60000);

    } catch (error) {

      this.$utilFront.errorhttp(error);

    } finally {

      this.sending = false;

    }

  },
  },
};
</script>
